import $ from 'jquery';
import { SCENE_EVENTS } from '../../MVC/Model';
import { SCENE_INTERACTION } from '../../../constants/scene';
import { findTourGuestByStreamId, findUserBySocektId } from '../../../socket/socketHelper';
import { tourID } from '../../../socket/SocketTour';

class JoinWorld {

  constructor({ model }) {
    this.model = model;
    this.opened = false;

    this.template = $("#invite_user_to_world");
    this.btnOk = $("#invite_user_to_world #join-world_ok_button");
    this.btnCancel = this.template.find("#cancel-join-world");
    this.socketUserWhoInvites = null;

    const onInvite = (e) => {

      this.close();
      const {
        onlineUser: {
          data: {
            userName,
            currentSceneName,
            userAvatarUrl
          }
        },
        url
      } = e.payload;
      this.url = url;
      this.socketUserWhoInvites = e.payload;
      this.template.find(".round-wrapper p").html(`${userName} <span data-lang="invitation-message">${$trans('invitation-message')}</span> ${currentSceneName}`);
      this.template.find(".local-avatar").attr("src", userAvatarUrl);
      this.btnOk.html("Go to room");

      this.btnOk.on("click", () => {
        const callback = () => {
          this.socketUserWhoInvites = null;
          window.location = window.location.protocol + "//" + window.location.host + "/worlds/view?" + this.url + "&security=" + this.model.config.security;
        }
        this.close();
        this.model.dispatchEvent({ type: SCENE_EVENTS.START_ANIMTAION_OUTRO, data: { onEndCallback: callback } })
      })
      this.open();
    }

    const onInviteOnTour = (e) => {
      this.close();
      const {
        data: {
          owner,
          name,
          userAvatarUrl
        },
        url
      } = e.payload;
      this.url = url;
      let ownerId = owner;
      let n = e.payload.data.userName;
      if (!ownerId) {
        return;
      }
      this.tourData = e.payload.data;
      this.btnOk.html("Join Tour");
      const user = findUserBySocektId(this.model.socket.getUsers(), ownerId);
      this.guide = user;
      console.log("user", user);
      this.socketUserWhoInvites = e.payload;
      this.template.find(".round-wrapper p").html(`${user.userName} <span data-lang="invitation-message-tour">${$trans('invitation-message')}</span> ${name}`);
      user.userAvatarUrl && this.template.find(".local-avatar").attr("src", user.userAvatarUrl);

      this.btnOk.on("click", () => {
        if (this.model.socket.getUserData().worldId !== Number(this.guide.worldId)) {
          window.location = window.location.protocol + "//" + window.location.host + "/worlds/view?" + this.url + "&tourId=" + this.tourData.id + "&security=" + this.model.config.security;
        }
        if (this.model.socket.getUserData().worldId === Number(this.guide.worldId)) {
          if (this.model.socket.getUserData().currentSceneId !== this.guide.currentSceneId) {
            this.nextSceneId = guide.currentSceneId;
            this.dispatchEvent({
              type: SCENE_INTERACTION.JUMP_TO_SCENE, data: {
                sceneId: guide.currentSceneId
              }
            });
          }
          const tour = this.model.findTourByOwner(this.guide.socketId);
          if (this.model.refuseOneToOneJoin(tour)) {
            this.model.info('info', $trans('one-to-one-tour-closed'));
            this.close();
            return;
          }
          this.model.onTourStarted();
          this.model.socket.acceptGuideMode(tour);
        }
        this.close();
        // this.model.dispatchEvent({ type: SCENE_EVENTS.START_ANIMTAION_OUTRO, data: { onEndCallback: callback } })
      })
      this.open();
    }
    const onInviteOnGlobalTour = (e) => {
      this.close();
      console.log(e)
      const {
        sender,
        tourData,
      } = e.payload;
      this.btnOk.html("Join Tour");
      this.socketUserWhoInvites = e.payload;
      let firstKey = Object.keys(tourData)[0];
      let name = tourData[firstKey].name
      this.template.find(".round-wrapper p").html(`${sender.userName} <span data-lang="invitation-message-tour">${$trans('invitation-message')}</span> ${name}`);
      sender.userAvatarUrl && this.template.find(".local-avatar").attr("src", sender.userAvatarUrl);
      this.btnOk.on("click", () => {
        const callback = () => {
          let id;
          Object.keys(tourData).forEach((key => {
            id = tourData[key].id;
          }))
          window.location = window.location.protocol + "//" + window.location.host + "/worlds/view?id=" + sender.worldId + "&tourId=" + id + "&security=" + this.model.config.security;
        }

        this.model.dispatchEvent({ type: SCENE_EVENTS.START_ANIMTAION_OUTRO, data: { onEndCallback: callback } })
        this.close();
      })
      this.open();
    }

    this.model.addEventListener(SCENE_EVENTS.GLOBAL_USER_JOIN_TOUR, onInvite)
    this.model.addEventListener(SCENE_EVENTS.GLOBAL_USER_JOIN_WORLD_INVITATAION, onInviteOnTour)
    this.model.addEventListener(SCENE_EVENTS.GLOBAL_USER_JOIN_WORLD_GLOBAL_INVITATAION, onInviteOnGlobalTour)

    this.btnCancel.on("click", () => {
      this.close();
    })

    this.open = (socketUser) => {
      this.template.addClass("is-active");
    }
    this.close = () => {
      this.template.removeClass("is-active");
    }
  }

}

export default JoinWorld